import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import {
  FormControl, InputGroup, Button, Modal,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { editSkill } from '../redux/reduxActions/actions';
import { showToastError } from './utils';


function EditSkillItem(props) {
  const [qualificationId, setSkill] = useState('');
  const [categoryId, setTechnology] = useState('');
  const [priorityId, setPriority] = useState('');
  const [minRate, setMinPayment] = useState(0);
  const [rate, setNormalPayment] = useState(0);
  const [description, setAdditionalInfo] = useState('');
  const {
    itemData, jobCategories, qualifications, priorities, isOpen,
  } = props;
  const validateAllFields = () => {
    setSkill(props.itemData.qualification_id);
    setTechnology(props.itemData.category_id);
    setPriority(props.itemData.priority_id);
    setMinPayment(props.itemData.min_rate);
    setNormalPayment(props.itemData.rate);
    setAdditionalInfo(props.itemData.description);
  };
  useEffect(() => {
    validateAllFields();
  }, [props]);
  const skillsSelection = Object.values(qualifications)
    .map((level, index) => <option key={level} value={index + 1}>{level}</option>);
  const categoriesSelection = Object.values(jobCategories)
    .map((category, index) => <option key={category} value={index + 1}>{category}</option>);
  const prioritySelection = Object.values(priorities)
    .map((priorityOption, index) => (
      <option key={priorityOption} value={index + 1}>
        {priorityOption}
      </option>
	    ));
  // eslint-disable-next-line react/prop-types
  const handleShow = () => props.show();


  const edit = () => {
    if (qualificationId.length === 0
      || priorityId.length === 0
      || categoryId.length === 0
      || minRate.length === 0
      || rate.length === 0
    ) {
      showToastError('Not all fields are filled');
      return;
    }
    const data = {
      id: itemData.id,
	    // eslint-disable-next-line camelcase
      qualification_id: qualificationId,
	    // eslint-disable-next-line camelcase
      category_id: categoryId,
	    // eslint-disable-next-line camelcase
      priority_id: priorityId,
	    // eslint-disable-next-line camelcase
      min_rate: minRate,
      rate,
      description,
    };
    props.editSkill(data);
    handleShow();
  };

  return (
    <div>
      <Modal show={isOpen} onHide={handleShow}>
        <Modal.Header closeButton>
          <Modal.Title>Edit technology</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: 'flex' }}>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Label>Skill</Form.Label>
              {/* eslint-disable-next-line react/prop-types,react/destructuring-assignment */}
              <Form.Control
                defaultValue={itemData.qualification_id}
                as="select"
                onChange={(e) => setSkill(e.target.value)}
              >
                <option key="" value="">none</option>
                {skillsSelection}
              </Form.Control>
            </Form.Group>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Label>technology</Form.Label>
              <Form.Control
                defaultValue={itemData.category_id}
                as="select"
                onChange={(e) => setTechnology(e.target.value)}
              >
                <option key="" value="">none</option>
                {categoriesSelection}
              </Form.Control>
            </Form.Group>
            <Form.Group style={{ width: '100%' }} controlId="formGridState">
              <Form.Label>priority</Form.Label>
              <Form.Control
                defaultValue={itemData.priority_id}
                as="select"
                onChange={(e) => setPriority(e.target.value)}
              >
                <option key="" value="">none</option>
                {prioritySelection}
              </Form.Control>
            </Form.Group>
          </div>
          <div className="money-inputs">
            <InputGroup size="sm" style={{ width: '100%' }} className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">min payment $</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                aria-label="Small"
                type="number"
                defaultValue={itemData.min_rate}
                aria-describedby="inputGroup-sizing-sm"
                onChange={({ target: { value } }) => setMinPayment(value)}
              />
            </InputGroup>
            <InputGroup size="sm" style={{ width: '100%' }} className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">normal payment $</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                aria-label="Small"
                type="number"
                defaultValue={itemData.rate}
                aria-describedby="inputGroup-sizing-sm"
                onChange={({ target: { value } }) => setNormalPayment(value)}
              />
            </InputGroup>
          </div>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Additional information</Form.Label>
            <Form.Control
              defaultValue={itemData.description}
              as="textarea"
              rows="3"
              onChange={({ target: { value } }) => setAdditionalInfo(value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleShow}>
            Close
          </Button>
          <Button variant="primary" onClick={() => edit()} className="main-button-filled">
            Edit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  qualifications: state.skillsReducer.qualifications,
  jobCategories: state.skillsReducer.jobCategories,
}), { editSkill })(EditSkillItem);
